module.exports = __webpack_public_path__ + "img/standard.4a66b07c.jpg";